import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import { CustomInput } from "../kits/Inputs/Inputs";

import ProductItemForOrder from "./ProductItemForOrder";
import Invoice from "./Invoice";
import RecipientData from "./RecipientData";

export default function CreateOrder({
  orderData,
  dispatch,
  ACTIONS,
  productDebounce,
  productListState,
  order,
}) {
  return (
    <div>
      <div className="my-2">
        <h5 className="title">محصولات انتخاب شده</h5>
        {orderData?.items?.map((value) => (
          <ProductItemForOrder
            dataItem={value}
            dispatch={dispatch}
            ACTIONS={ACTIONS}
            productDebounce={productDebounce}
            productListState={productListState}
            order={order}
          />
        ))}
      </div>
      <div className="d-flex align-items-center">
        <div style={{ width: 100 }} className="mb-2 mt-3 ">
          <label className="title">زمان سفارش</label>
          <DatePicker
            value={
              orderData?.order_date != "" &&
              orderData?.order_date != undefined &&
              orderData?.order_date != null
                ? parseInt(orderData?.order_date) * 1000
                : ""
            }
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            onChange={(e) => {
              dispatch({
                type: ACTIONS.CHANGEPUBLIC,
                payload: { order_date: e.unix },
              });
            }}
          />
        </div>
        <div className="mb-2 mt-3 flex-grow-1 ms-1">
          <h5 className="title">توضیحات</h5>
          <CustomInput
            inputType="textarea"
            inputValue={orderData?.description}
            onChangeFunc={(e) => {
              dispatch({
                type: ACTIONS.CHANGEPUBLIC,
                payload: { description: e.target.value },
              });
            }}
          />
        </div>
      </div>

      <div className="mb-2 mt-5 ">
        <h5 className="title">پیش نمایش</h5>
        <Invoice dataFactor={orderData} dispatch={dispatch} ACTIONS={ACTIONS} />
      </div>

      <div className="mb-2 mt-5">
        <h5 className="title">اطلاعات گیرنده</h5>
        <RecipientData data={orderData} dispatch={dispatch} ACTIONS={ACTIONS} />
      </div>
    </div>
  );
}
